var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKnowledge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 491.52 491.52",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,0v491.52h491.52V0H0z M471.04,471.04H20.48V102.4h450.56V471.04z M471.04,81.92H20.48V20.48h450.56V81.92z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 430.08,
    y: 40.96,
    width: 20.48,
    height: 20.48
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 389.12,
    y: 40.96,
    width: 20.48,
    height: 20.48
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 348.16,
    y: 40.96,
    width: 20.48,
    height: 20.48
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 51.2,
    y: 40.96,
    width: 245.76,
    height: 20.48
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M245.76,215.04c0-50.815-41.345-92.16-92.16-92.16s-92.16,41.345-92.16,92.16c0,47.35,35.912,86.441,81.92,91.556v12.731 c-11.894,4.241-20.48,15.501-20.48,28.833v71.68c0,16.94,13.78,30.72,30.72,30.72s30.72-13.78,30.72-30.72v-71.68 c0-13.332-8.586-24.592-20.48-28.833v-12.731C209.848,301.481,245.76,262.39,245.76,215.04z M163.84,419.84 c0,5.645-4.595,10.24-10.24,10.24c-5.645,0-10.24-4.595-10.24-10.24v-71.68c0-5.645,4.595-10.24,10.24-10.24 c5.645,0,10.24,4.595,10.24,10.24V419.84z M153.6,286.72c-39.525,0-71.68-32.155-71.68-71.68c0-39.525,32.155-71.68,71.68-71.68 c39.525,0,71.68,32.155,71.68,71.68C225.28,254.565,193.125,286.72,153.6,286.72z"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 348.16,
    y: 215.04,
    width: 92.16,
    height: 20.48
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 276.48,
    y: 276.48,
    width: 163.84,
    height: 20.48
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 317.44,
    y: 337.92,
    width: 122.88,
    height: 20.48
  })))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 225.28,
    y: 399.36,
    width: 215.04,
    height: 20.48
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledge);
export default __webpack_public_path__ + "static/media/knowledge.0f76bd7925a1ab23d3b4cbe2c1c54c42.svg";
export { ForwardRef as ReactComponent };